import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NavService } from '../../core/nav.service';
import { LectureService } from '../shared/lecture.service';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-lectures',
  templateUrl: './lectures.component.html',
  styleUrls: ['./lectures.component.scss']
})
export class LecturesComponent implements OnInit {
  filter: Observable<any>;
  AppConfig: any;

  constructor(route: ActivatedRoute, private nav: NavService, public service: LectureService) {
    this.filter = route.params
      .pluck('billing')
      .do((value: string) => service.filterBilling(value));
  }

  ngOnInit() {
    this.initNav();
    this.AppConfig = APPCONFIG;
  }

  get title() {
    return this.nav.title;
  }

  private initNav() {
    this.nav.title = '강의 목록';
    this.nav.actions = [
      { text: '강좌로 돌아가기', commands: ['/'] }
    ];
    this.nav.slackUrl = null;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lectures/lectures.component.ts